import { Link } from "react-router-dom";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { CocoonMark } from "@/components/CocoonMark";

export function EssaiHeader({ to, label }) {
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass">
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="font-display text-2xl tracking-tight"><CocoonMark withMind /></Link>
        <div className="flex items-center gap-4">
          <LanguageSwitcher />
          <Link to={to} className="text-sm text-foreground/60 hover:text-primary transition-colors" data-testid="essai-back-link">← {label}</Link>
        </div>
      </div>
    </header>
  );
}
